import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, admin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, David.");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] grain px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-[#111] border border-[#2A2A2A] p-10">
        <p className="smallcaps mb-3">Workshop</p>
        <h1 className="font-display text-3xl text-[#F5F5DC] mb-8">Admin Login</h1>
        <label className="smallcaps block mb-2">Email</label>
        <input data-testid="admin-email" type="email" required className="input-dark mb-5" value={email} onChange={(e) => setEmail(e.target.value)} />
        <label className="smallcaps block mb-2">Password</label>
        <input data-testid="admin-password" type="password" required className="input-dark mb-8" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full justify-center">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
